export const ONE_STEPS_CONTAINER = 1

export const STEP_POSITION = {
  FIRST_STEP: 'first_step',
  LAST_STEP: 'last_step',
  OTHER: 'other',
  FIRST_AND_LAST_STEP: 'first_and_last',
}
